import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'CollectionBanner',
  components: {
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12;

      return {
        background_color: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.background_color : _ref12 : _ref12) || '',
        background_image: {
          small: formatPrismicImage((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.background_image) != null ? (_ref11 = _ref11.small) != null ? _ref11.url : _ref11 : _ref11 : _ref11 : _ref11) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? (_ref10 = _ref10.background_image) != null ? (_ref10 = _ref10.medium) != null ? _ref10.url : _ref10 : _ref10 : _ref10 : _ref10) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.background_image) != null ? (_ref9 = _ref9.large) != null ? _ref9.url : _ref9 : _ref9 : _ref9 : _ref9) || EMPTY_PIXEL
        },
        title: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.title_banner : _ref8 : _ref8) || '',
        subtitle: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.subtitle_banner : _ref7 : _ref7) || '',
        text_color: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.text_color : _ref6 : _ref6) || '',
        button: {
          text: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.button_text : _ref5 : _ref5) || '',
          url: new UrlParse(((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.button_url) != null ? _ref4.url : _ref4 : _ref4 : _ref4) || '').pathname
        },
        tracking: {
          data: {
            event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
            event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
            event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
          }
        }
      };
    },
    hasBackgroundImage: function hasBackgroundImage() {
      return !!this.payload.primary.background_image.small.url && !!this.payload.primary.background_image.medium.url && !!this.payload.primary.background_image.large.url;
    }
  }
};